
import Card from './card';
import CardsProps from './mixins/CardsProps';
import { CardsProperty, CardProperty } from './enums';
import { ControlEventType, ControlType } from '../../enums';
import StylesMixin from '../../../../../mixins/styles';

export default {
  name: 'Cards',
  components: {
    Card,
  },
  mixins: [
    CardsProps,
    StylesMixin,
  ],
  data() {
    return {
      CardsProperty,
      CardProperty,
    };
  },
  computed: {
    cardName() {
      return this[CardsProperty.Name];
    },
    isCardDisabled() {
      return this[CardsProperty.Disabled];
    },
    controlType() {
      return this[CardsProperty.Multiple] ? ControlType.Checkbox : ControlType.Radio;
    },
  },
  methods: {
    getKey(option) {
      return `${this[CardsProperty.Value]}-${option.value}-${option.label}`;
    },
    getIsCardActive(value) {
      if (this[CardsProperty.Multiple]) {
        return this[CardsProperty.Value]?.includes(value);
      }

      return this[CardsProperty.Value] === value;
    },
    handleChange(value) {
      this.$emit(ControlEventType.Change, this.getResultValue(value));
    },
    getResultValue(value) {
      if (this[CardsProperty.Multiple]) {
        return this.getIsCardActive(value)
          ? this[CardsProperty.Value]?.filter((valueItem) => valueItem !== value)
          : [...(this[CardsProperty.Value] || []), value];
      }

      return value;
    },
  },
};
